import { api } from "@/lib/api";

export async function platform() {
  try {
    const { Capacitor } = await import("@capacitor/core");
    return Capacitor.getPlatform();
  } catch {
    return "web";
  }
}

export async function configurePurchases(appUserId) {
  const which = await platform();
  if (which === "web" || !appUserId) return false;
  const apiKey = which === "ios"
    ? process.env.REACT_APP_REVENUECAT_IOS_KEY
    : process.env.REACT_APP_REVENUECAT_ANDROID_KEY;
  if (!apiKey) return false;
  const { Purchases } = await import("@revenuecat/purchases-capacitor");
  await Purchases.configure({ apiKey, appUserID: appUserId });
  return true;
}

export async function purchaseProduct(productId, offeringId) {
  const { Purchases } = await import("@revenuecat/purchases-capacitor");
  const offerings = await Purchases.getOfferings();
  const offering = offerings.all?.[offeringId] || offerings.current;
  if (!offering) throw new Error("No subscription offering is available from the store yet.");
  const packages = offering.availablePackages || [];
  const wanted = productId.includes("yearly") ? "ANNUAL" : "MONTHLY";
  const matchesProduct = (identifier) => {
    const id = String(identifier || "");
    // Play base plans arrive as "productId:basePlanId"; iOS stays bare productId.
    return id === productId || id.startsWith(`${productId}:`) || id.split(":")[0] === productId;
  };
  const pack = packages.find((item) => matchesProduct(item.product?.identifier))
    || packages.find((item) => String(item.packageType).toUpperCase().includes(wanted))
    || packages.find((item) => (item.identifier || "").includes(productId.includes("yearly") ? "year" : "month"));
  if (!pack) throw new Error("That plan isn't in the current store offering.");
  await Purchases.purchasePackage({ aPackage: pack });
  const restored = await api.post("/billing/restore");
  return restored.data.user;
}

export async function restorePurchases() {
  const which = await platform();
  if (which !== "web") {
    try {
      const { Purchases } = await import("@revenuecat/purchases-capacitor");
      await Purchases.restorePurchases();
    } catch (error) {
      // Still ask the backend; a webhook may already have recorded the purchase.
      console.error(error);
    }
  }
  const restored = await api.post("/billing/restore");
  return restored.data;
}

export async function openCheckout(productId) {
  const origin = window.location.origin;
  const response = await api.post("/billing/checkout", { product_id: productId, origin_url: origin });
  const url = response.data.checkout_url;
  const which = await platform();
  if (which !== "web") {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
    return;
  }
  window.location.href = url;
}

export async function manageSubscription(user) {
  const provider = user?.subscription?.provider;
  const which = await platform();
  if (provider === "stripe" || which === "web") {
    if (provider === "stripe") {
      const response = await api.post("/billing/portal", { origin_url: window.location.origin });
      window.location.href = response.data.url;
      return;
    }
  }
  if (which === "ios") {
    window.open("https://apps.apple.com/account/subscriptions", "_blank");
    return;
  }
  if (which === "android") {
    window.open("https://play.google.com/store/account/subscriptions?package=com.jobspoken.app", "_blank");
    return;
  }
  const response = await api.post("/billing/portal", { origin_url: window.location.origin });
  window.location.href = response.data.url;
}
